import React, { useEffect, useState } from "react";
import { useSession } from "./Session";
import { apiCall } from "./Api"
import Cookies from "js-cookie";
import { Button, Divider, Modal, message } from "antd";

export default function PubSub(props) {


    const mode = process.env.REACT_APP_API || 'inherit';
    const live_cookie = Cookies.get("l") || "false";
    const is_live = ((live_cookie === "true") || (mode === "live")) ? true : false;
    const [session, setSession] = useSession();
    const [s, setS] = useState({ store_id: "", store_name: "" });
    const [open, setOpen] = useState(false);


    // session context isn't updating inside the pubsub event methods - using a window var
    useEffect(() => {
        window.pubsub_session = session;
    }, [session])

    const autobahn = window.autobahn;
    const principal = session.store_id;
    const ticket = session.session_id;

    var msgpser = new autobahn.serializer.MsgpackSerializer();
    var jsonser = new autobahn.serializer.JSONSerializer();

    const toURI = (_string) => {
        let no_whitespace = _string.replace(/\s+/g, '-');
        let sanitized = no_whitespace.replace(/[^A-Za-z0-9-]+/g, '', no_whitespace);
        return sanitized;
    }

    const onCorp = (_args) => {

        if (Array.isArray(_args) && _args.length > 0 && _args[0] === "reset") {
            apiCall("session/get", {}, (_status, _result) => {
                if (_status) {
                    setS(_result);
                    if (_result.store_id === session.store_id) {
                        setOpen(false)
                    } else {
                        setOpen(true);
                    }
                }
            })
        }
        return;
    }


    const switchStore = (id) => {
        apiCall("account/setCorp", { corp_id: id }, (_status, _result) => {
            if (_status) {
                setOpen(false);
            } else {
                message.error(_result.error)
            }
        })
    }



    const onChallenge = (_session, _method, _extra) => {
        if (_method === "ticket") { return ticket; }
        console.log("Can't authenticate using '" + _method + "'");
    }

    const connection = new autobahn.Connection({
        url: 'wss://bookmanager.com/ws/',
        realm: 'bookmanager',
        authmethods: ["ticket"],
        // authid: principal.toString(),
        authid: principal.toString() + "-" + session.picklist_identity,
        onchallenge: onChallenge,
        serializers: [msgpser, jsonser]
    });


    connection.onopen = function (_session) {

        window.ses = _session;
        window.wamp_session_id = _session.id;

        // USER BROWSER LEVEL (TABS) 
        let corp_path = "com.bookmanager." + session.session_channel_id + ".corp";
        window.ses.subscribe(corp_path, onCorp);

    };

    connection.onclose = function (reason, details) {
        console.log("disconnected", reason, details.reason, details);
    }

    useEffect(() => {

        if (is_live) {
            connection.open();
        }

        return () => connection.close();
    }, [session.picklist_identity]);



    const drawMessage = () => {

        return (<div>
            <p>You were previously logged in as: <strong>{session.store_name}</strong>, but have since swiched your location to <strong>{s.store_name}</strong>. <br /><br />Proceeding further will result in losing any changes that haven't been saved.</p>
            <Divider dashed style={{"margin" : "15px 0px"}} />
            <div className="float-flex">
                <Button danger onClick={() => window.location.reload()}>Proceed as:&nbsp;<em>{s.store_name}</em></Button>
                <Button type="primary" onClick={() => switchStore(session.store_id)}>Restore to:&nbsp;<em>{session.store_name}</em></Button>
            </div>
        </div>);


        // "store_name": "Test Multi Store #0",
        // "store_id": 101069,
    }


    return (<><Modal title="Store location changed" footer={null} open={open}>{drawMessage()}</Modal></>);

}